import React, { useCallback } from 'react';
import { View, StyleSheet } from 'react-native';
import TouchableHighlight from 'utils/packages/TouchableHighlight';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import Logo from 'design-system/Logo';
import { rem } from 'design-system/values';
import BlurAmountView from 'design-system/BlurAmountView';
import useColors from 'hooks/useColors';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { useAppSelector } from 'store/hooks';
import { formatPlural } from 'utils/formatting';
import { ROW_ITEM_VERTICAL_PADDING, ROW_ITEM_HORIZONTAL_PADDING } from '../constants';
import { useStockMeta } from '../hooks/selectors';
import { formatNumberOfSharesAmount } from '../utils';
import FormattedAmount from './FormattedAmount';
import FormattedPriceChangePct from './FormattedPriceChangePct';
import { selectIsTradingAccountAlpaca } from '../reducers/selectors';
import { isWeb } from '../../../constants';
const Position = ({ item }) => {
    const stockCache = useStockMeta(item.assetId);
    const scrambled = useAppSelector((store) => store.utils.scrambled);
    const { navigateDeprecated } = useMainStackNavigation();
    const isTradingAccountAlpaca = useAppSelector(selectIsTradingAccountAlpaca);
    const colors = useColors();
    const onPress = useCallback(() => {
        navigateDeprecated('InvestStock', { assetId: item.assetId });
    }, [navigateDeprecated, item.assetId]);
    return (<TouchableHighlight hoverOnLight onCard={isWeb} underlayColor={colors.background.underlay} activeOpacity={1} onPress={onPress}>
      <View style={styles.itemContainer}>
        <Logo R44 uri={stockCache?.iconUrl} resizeMode="contain"/>
        <Spacer w={16}/>
        <View style={styles.infoContainer}>
          <View style={styles.infoRow}>
            <View style={styles.assetInfo}>
              <Text Text-16 numberOfLines={1}>
                {stockCache?.name ?? item.symbol ?? ''}
              </Text>
              <Text TextThin-14 Gray>
                {!!item.symbol && !!isTradingAccountAlpaca && (<>
                    <Text TextThin-14 Gray>
                      {`$${item.symbol}`}
                    </Text>
                    <Text TextThin-14 style={styles.bullet} Gray>
                      {'  •  '}
                    </Text>
                  </>)}
                <Text NumbersThin-14 Gray>
                  {formatNumberOfSharesAmount(item.quantity)}
                </Text>{' '}
                {formatPlural('share', 'shares', item.quantity)}
              </Text>
            </View>
            <Spacer w={8}/>
            <View style={styles.pricesContainer}>
              <BlurAmountView enabled={scrambled}>
                <FormattedAmount amount={item.amount}/>
              </BlurAmountView>
              <Spacer h={2}/>
              <BlurAmountView enabled={scrambled}>
                <FormattedPriceChangePct priceChangePct={item.unrealizedProfitLossPct}/>
              </BlurAmountView>
            </View>
          </View>
        </View>
      </View>
    </TouchableHighlight>);
};
const styles = StyleSheet.create({
    itemContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: rem(ROW_ITEM_HORIZONTAL_PADDING),
        paddingVertical: rem(ROW_ITEM_VERTICAL_PADDING),
        // On web the card is padded by 8 and each row by 8, so the hover highlight sits inside the card
        ...(isWeb && { paddingHorizontal: rem(8) }),
    },
    infoContainer: { flex: 1 },
    infoRow: {
        flexDirection: 'row',
    },
    bullet: {
        fontWeight: '900',
    },
    assetInfo: {
        flex: 1,
        justifyContent: 'center',
    },
    pricesContainer: {
        alignItems: 'flex-end',
    },
});
export default Position;
